import * as segmentio from 'rp-analytics';

export default function analyticsPage() {
    segmentio.setCommonTraits({
        [segmentio.TRAIT_SITE_SECTION]: 'Bloodstock',
        [segmentio.TRAIT_SITE_SUB_SECTION_1]: 'Stallion Book',
        [segmentio.TRAIT_SITE_SUB_SECTION_2]: null,
    });

    segmentio.page();
}



// WEBPACK FOOTER //
// ./src/client/analyticsPage.js